import React from 'react';

const VideoTest = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Video Test Page</h1>
      
      <h2>Direct Video Element Test</h2>
      <video 
        width="400" 
        height="300" 
        controls
        onLoadStart={() => console.log('Video load started')}
        onLoadedData={() => console.log('Video data loaded')}
        onCanPlay={() => console.log('Video can play')}
        onError={(e) => console.error('Video error:', e)}
      >
        <source src="/assets/videos/hero-video-home.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <h2>Video File Info</h2>
      <ul>
        <li>Path: /assets/videos/hero-video-home.mp4</li>
        <li>Expected location: public/assets/videos/hero-video-home.mp4</li>
      </ul>
      
      <h2>Test Links</h2>
      <ul>
        <li><a href="/assets/videos/hero-video-home.mp4" target="_blank">Direct video link</a></li>
        <li><a href="/assets/videos/hero-video-kurse.mp4" target="_blank">Kurse video link</a></li>
        <li><a href="/assets/videos/hero-video-impule.mp4" target="_blank">Impulse video link</a></li>
      </ul>
    </div>
  );
};

export default VideoTest;
